//* Providers
import LanguageProvider from './providers/LanguageProvider'
import UIProvider from './providers/UIProvider'
import DataProvider from './providers/DataProvider'
import UserProvider from './providers/UserProvider'
import CartProvider from "./providers/CartProvider"

//* ConsumerHOC
import withLanguageContext from './consumerHOC/LanguageConsumer'
import withUIContext from './consumerHOC/UIConsumer'
import withDataContext from './consumerHOC/DataConsumer'
import withUserContext from './consumerHOC/UserConsumer'
import withCartContext from "./consumerHOC/CartConsumer"

export { LanguageProvider, UIProvider, DataProvider, UserProvider, CartProvider, withLanguageContext, withUIContext, withDataContext, withUserContext, withCartContext }
